const en = {
  add_user_agreement:
    "I understand that adding user licenses might result in additional charges, depending on the terms outlined in my contract.",
  // TODO: Get the correct CTA URL from the Akeneo team — without it the "Read more" button on the auth page will be broken
  "custom.auth.description": " ",
  "custom.auth.hero_text": " ",
  "footer.message": "Version {appVersion} - Akeneo",
  "links.CLI_download": "https://cli.akeneo.cloud/installer",
  no_credit_card_signup: "Register for free",
  "no_organization_access.description":
    "Your account isn't part of an organization on Akeneo yet. After your admin adds you, you'll see your projects here.",
  "no_organization_access.title":
    "Ask your admin to add you to an organization",
  "setup.cli.install.code":
    "curl -sfS https://cli.akeneo.cloud/installer | php",
  "setup.cli.install.label": "Install CLI",
  try_us_for_free: "Create your account",
  "url.logo_url": "https://akeneo.com"
};

export default en;
